import { Box, Checkbox, Divider, Flex, Text } from "@chakra-ui/react";
import moment from "moment-timezone";
import { shortenUUID } from "../../../utils/shortenUUID";

const CaseCard = ({
  item,
  onSelectionChange,
  isSelected,
  isFirst,
  selectedPrimary,
  setSelectedPrimary,
  selectedSecondary,
  setSelectedSecondary,
}) => {
  const { id } = item;

  const isPrimary = selectedPrimary?.id === id;
  const isSecondary = selectedSecondary.some((sec) => sec.id === id);

  const handlePrimaryChange = (event) => {
    if (event.target.checked) {
      setSelectedPrimary(item);
      setSelectedSecondary(selectedSecondary.filter((sec) => sec.id !== id));
    } else {
      setSelectedPrimary(null);
    }
  };

  const handleSecondaryChange = (event) => {
    if (event.target.checked) {
      setSelectedSecondary([...selectedSecondary, item]);
      if (isPrimary) setSelectedPrimary(null);
    } else {
      setSelectedSecondary(selectedSecondary.filter((sec) => sec.id !== id));
    }
  };

  const handleCheckboxChange = (event) => {
    if (onSelectionChange && !isFirst) {
      onSelectionChange(item, event.target.checked);
    }
  };

  return (
    <Box
      p={2}
      bg="gray.100"
      boxShadow="md"
      borderRadius="md"
      textAlign="left"
      mt={2}
      display="flex"
      alignItems="center"
      flexDir="column"
      maxH="75vh"
      h="60vh"
      overflowY="scroll"
      scrollBehavior="smooth"
      w="100%"
    >
      {/* Checkbox Controls */}
      <Flex alignItems="center" justify="space-between" w="100%" fontSize="sm">
        <Box>
          <Checkbox
            colorScheme="teal"
            size="sm"
            isChecked={isPrimary}
            onChange={handlePrimaryChange}
            mb={1}
            fontWeight={600}
          >
            Primary
          </Checkbox>
          <Checkbox
            ml={2}
            colorScheme="orange"
            size="sm"
            isChecked={isSecondary}
            onChange={handleSecondaryChange}
            mb={1}
            isDisabled={isPrimary}
            fontWeight={600}
          >
            Secondary
          </Checkbox>
        </Box>
        <Box>
          <Checkbox
            colorScheme="green"
            size="sm"
            isChecked={isSelected}
            onChange={handleCheckboxChange}
            mb={1}
            isDisabled={isFirst}
          >
            Select
          </Checkbox>
        </Box>
      </Flex>
      <Box w="100%">
        {Object.entries(item).map(([key, value]) => {
          // Check if the value is an array
          if (Array.isArray(value)) {
            return (
              <Flex
                key={key}
                justifyContent="space-evenly"
                fontSize="sm"
                py={1}
              >
                <Box textAlign="left" w="50%" fontWeight={400}>
                  {key.replace(/_/g, " ")}
                </Box>
                <Box textAlign="center"> : </Box>
                <Box textAlign="left" width="50%" ml={4}>
                  <Text wordBreak="break-word">{` ${value.length}`}</Text>
                </Box>
              </Flex>
            );
          }
          return null; // Skip non-array fields
        })}
      </Box>
      <Divider borderColor="bgColor" />
      {/* Dynamic Key-Value Display */}
      <Box w="100%" mx="auto">
        {Object.entries(item).map(([key, value]) => {
          const skipKeys = [
            "_etag",
            "_rid",
            "_self",
            "_ts",
            "_attachments",
            "LAB",
            "INTERVIEW",
            "BASIS",
            "TREATMENT",
          ];

          const isArrayOfObjects =
            Array.isArray(value) &&
            value.length > 0 &&
            typeof value[0] === "object";

          if (isArrayOfObjects || skipKeys.includes(key)) return null;
          const isDateField =
            typeof value === "string" &&
            /^\d{8}$/.test(value) &&
            key.toLowerCase().includes("date");

          const displayValue =
            value === null || value === undefined
              ? ""
              : isDateField
              ? moment(value, "YYYYMMDD").format("MM/DD/YYYY")
              : key === "PERSON_ID"
              ? shortenUUID(value)
              : value.toString();

          return (
            <Flex key={key} justifyContent="space-evenly" fontSize="sm" py={1}>
              <Box textAlign="left" w="50%" fontWeight={400}>
                {key.replace(/_/g, " ")}
              </Box>
              <Box textAlign="center"> : </Box>
              <Box textAlign="left" width="50%" ml={4}>
                <Text wordBreak="break-word">{displayValue}</Text>
              </Box>
            </Flex>
          );
        })}
      </Box>
    </Box>
  );
};

export default CaseCard;
